import createError from './create-error';

const requestCache = new Map();

function getRequestCacheKey(config) {
    const map = new Map();
    const url = config.url.split('?');
    if (url.length > 1) {
        url[1].split('&').forEach(element => {
            element = element.split('=');
            map.set(element[0], element.length > 1 ? element[1] : '');
        });
    }
    for (const key in config.headers) {
        if (
            key === 'Authorization' ||
            key === 'Cache-Control' ||
            key === 'Accept' ||
            key === 'Content-Type'
        ) {
            map.set(key, config.headers[key]);
        }
    }
    for (const key in config.params) {
        map.set(key, config.params[key]);
    }
    let data = config.data;
    if (typeof data === 'string') {
        data = {};
        config.data.split('&').forEach(p => {
            p = p.split('=');
            data[p[0]] = p[1];
        });
    }
    for (const key in data) {
        map.set(key, data[key]);
    }

    const hashes = [config.method.toUpperCase(), url[0]];
    const keys = [];
    for (const key of map.keys()) {
        keys.push(key);
    }
    keys.sort().forEach(key => {
        hashes.push(`${key}=${map.get(key)}`);
    });
    return encodeURIComponent(hashes.join('|'));
}

function deleteRequestCache(config) {
    const cacheKey = getRequestCacheKey(config);
    if (requestCache.has(cacheKey)) {
        requestCache.delete(cacheKey);
    }
}

export default function request(axiosInstance, config) {
    if (config.headers['Content-Type'] === 'multipart/form-data') {
        return promiseRequest(axiosInstance, config);
    }
    const cacheKey = getRequestCacheKey(config);
    if (!requestCache.has(cacheKey)) {
        requestCache.set(cacheKey, promiseRequest(axiosInstance, config));
    }
    return requestCache.get(cacheKey);
}

async function promiseRequest(axiosInstance, config) {
    const res = await axiosInstance.request(config).catch(error => {
        deleteRequestCache(error.config);
        let e = error;
        if (error.response && error.response.status === 401) {
            e = createError(
                'Invalid accessToken',
                error.config,
                -1,
                error.request,
                error.response
            );
        }
        throw e;
    });
    deleteRequestCache(res.config);
    const status = res.data.status ||
        res.data.Status || {
            ErrorCode: res.data.ErrorCode,
            SubErrorCode: res.data.SubErrorCode
        };
    if (
        (status.errorCode === '-1' || status.ErrorCode === '-1') &&
        (status.subErrorCode === '10000' || status.SubErrorCode === '10000')
    ) {
        throw createError(
            'Invalid sessionId',
            res.config,
            -1,
            res.request,
            res
        );
    } else {
        return res;
    }
}
